import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledFilterHeading = styled.p`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])}
    margin-bottom: 8px;
`;
